<template>
  <div class="baseball-list list-team-table">
      <template v-if="hasCellList">
        <div class="list-view-detail">
          <component
            v-for="(cell, index) in cellList"
            :key="'list_cell_' + index"
            :is="thumbnailInfo.componentName"
            :cell-info="cell"
            :cell-type="cellType"
            :thumbnail-info="thumbnailInfo"></component>
        </div>
        <paging-component
          v-if="!isLoading"
          :is-loading="isLoading"
          :page-count="pageCount"
          :limit="limit"
          :paging-count="10"
          :current-page="currentPage"
        ></paging-component>
      </template>
      <template v-else-if="!hasCellList">
        <empty-baseball-cell title="선택한 일자는 경기 영상이 없어요.">
          <img slot="icon" src="../../assets/images/kbo/icon-schedule.png" alt="알림">
        </empty-baseball-cell>
      </template>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { apiRequest, applyQueryString } from '@/common/utils/request.common'
  import { parseUrl } from 'query-string'
  import { HTTP_METHOD_GET } from '@/common/utils/request.const'
  import { convertSpecialSymbols } from '@/common/resources/directives'
  import FilterList from '@/pages/list/FilterList'
  import { getThumbnailInfo, setDisableScrolling } from '@/common/utils/common'
  import LandscapeCell from '@/components/model/cell/LandscapeCell'
  import PortraitCell from '@/components/model/cell/PortraitCell'
  import PagingComponent from '@/components/common/PagingComponent'
  import EmptyList from '@/pages/list/EmptyList'
  import EditorPickHeader from '@/pages/list/EditorPickHeader'
  import EmptyBaseballCell from '@/components/model/cell/EmptyBaseballCell'
  import { mapMutations } from 'vuex'
  import { SET_CURRENT_MENU } from '@/common/resources/const'
  export default {
    name: 'BaseBallHighLightList',
    props: {
      currentDate: {
        type: Date
      },
      teamCode: {
        type: String
      }
    },
    components: {
      FilterList,
      LandscapeCell,
      PortraitCell,
      PagingComponent,
      EmptyList,
      EditorPickHeader,
      EmptyBaseballCell
    },
    data () {
      return {
        isLoading: true,
        uiCode: null,
        cellType: '',
        cellList: [],
        filter: null,
        title: '',
        thumbnailInfo: null,
        url: null,
        query: null,
        currentPage: 1,
        pageCount: 0,
        limit: 20,
        pagingCount: 10,
        titleList: [],
        subType: '',
        topButtonList: []
      }
    },
    computed: {
      hasCellList () {
        return this.cellList.length > 0
      }
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU]),
      setData () {
        this.isLoading = true
        const clearCellList = data => { this.cellList = []; return data }
        const CELL_TYPE_PATH = ['cell_toplist', 'cell_type']
        const getData = response => response.data
        const routerReplaceIfNeed = data => {
          const hasQueryDate = _.get(this.$route, 'query.date', '') !== ''
          const cellDate = _.get(data, 'cell_toplist.celllist.0.date', '')
         if (!hasQueryDate && cellDate !== '') {
            this.$router.replace(
              { path: `/baseball/highlight/${this.$route.params.uiCode}`,
                query: Object.assign({}, this.$route.query, { date: cellDate })
            }).catch(() => {})
          }
          return data
        }
        const setCellType = data => { this.cellType = _.get(data, CELL_TYPE_PATH, ''); return data }
        const setCellList = data => { this.cellList = _.get(data, ['cell_toplist', 'celllist'], []); return data }
        const setFilter = data => { this.filter = _.get(data, 'filter', {}); return data }
        const setPageCount = data => { this.pageCount = Number(_.get(data, ['cell_toplist', 'pagecount'], '0')); return data }
        const setThumbnailInfo = data => { this.thumbnailInfo = getThumbnailInfo(_.get(data, CELL_TYPE_PATH, '')); return data }
        const setTitle = data => { this.title = convertSpecialSymbols(_.get(data, ['cell_toplist', 'title_list', '0', 'text'], '')); return data }
        const setTitleList = data => { this.titleList = _.get(data, ['cell_toplist', 'title_list'], []); return data }
        const setSubTitle = data => { this.subType = _.get(data, 'sub_type', ''); return data }
        const setTopButtonList = data => { this.topButtonList = _.get(data, ['cell_toplist', 'topbuttonlist'], []); return data }
        const scrollToTop = () => { window.scrollTo(0, 0) }
        const loadComplete = () => { this.isLoading = false }
        const req = { url: applyQueryString(`https://${this.url}`, this.query), method: HTTP_METHOD_GET }
        apiRequest(req)
          .then(getData)
          .then(routerReplaceIfNeed)
          .then(setTitle)
          .then(setFilter)
          .then(setTitleList)
          .then(setTopButtonList)
          .then(setSubTitle)
          .then(setCellType)
          .then(setThumbnailInfo)
          .then(clearCellList)
          .then(setCellList)
          .then(setPageCount)
          .then(scrollToTop)
          .then(loadComplete)
      },
      updateQuery () {
        this.setPagingQuery()
        this.setTeamQuery()
        this.setDateQuery()
      },
      getCurrentApiQuery () {
        const { query } = parseUrl(decodeURIComponent(_.get(this.$route, 'query.api', '')))
        return query
      },
      setPagingQuery () {
        const pageNum = Number(_.get(this.$route, 'query.page', '1'))
        const query = this.getCurrentApiQuery()
        this.currentPage = +pageNum
        const pagingAppliedQuery = _.assign({}, query, { offset: (pageNum - 1) * this.limit })
        this.query = _.assign({}, this.query, pagingAppliedQuery)
      },
      setTeamQuery () {
        const teamCode = _.get(this.$route, 'query.team', 'all').toUpperCase()
        const query = this.getCurrentApiQuery()
        const teamCodeAppliedQuery = _.assign({}, query, { team: teamCode })
        this.query = _.assign({}, this.query, teamCodeAppliedQuery)
      },
      setDateQuery () {
        const date = _.get(this.$route, 'query.date', '')
        const query = this.getCurrentApiQuery()
        const dateAppliedQuery = _.assign({}, query, { date: date })
        this.query = _.assign({}, this.query, dateAppliedQuery)
      },
      applyPagingQuery (query, pageNum) {
        this.currentPage = +pageNum
        return _.assign({}, query, { offset: (pageNum - 1) * this.limit })
      },
      initialize () {
        const { url, query } = parseUrl(decodeURIComponent(_.get(this.$route, 'query.api', '')))
        this.url = url
        this.query = query
        this.updateQuery()
        this.setData()
      },
      setCurrentMenu () {
        const menu = _.get(this.$route, ['query', 'came'], '')
        this[SET_CURRENT_MENU](menu)
      }
    },
    created () {
      setDisableScrolling(false)
      this.setCurrentMenu()
      this.initialize()
    },
    watch: {
      $route (newRoute, oldRoute) {
        const routeQuery = _.get(newRoute, 'query', {})
        this.updateQuery(routeQuery)
        this.initialize()
      }
    }
  }
</script>
<style>
  .empty_list {
    position: relative;
    width: 100%;
    height: 400px;
    margin-top: 200px;
    text-align: center;
  }

  .empty_list > p{
    margin-top: 12px;
    font-size: 18px;
    line-height: 1;
    color: #a5a5a5;
  }

  .empty_list img{
    width: 74px;
  }
</style>
